module.exports = __webpack_public_path__ + "img/page_image_2_4.6b0e3cdc.svg";